<template>
  <div class="search-box">
    <el-form ref="form" :inline="true" :model="ruleForm" class="demo-form-inline" size="mini" >
      <!-- <el-form-item label="编号：" prop="code">
        <el-input v-model="ruleForm.userId " style="max-width:180px;" clearable></el-input>
      </el-form-item> -->
      <el-form-item label="机构">
        <dep-code-tree v-model="ruleForm.depCode" :dep-code="userInfor.depCode"/>
      </el-form-item>
      <el-form-item label="任务类型">
        <el-select v-model="ruleForm.taskType" clearable placeholder style="max-width:180px;">
          <el-option
            v-for="item in manOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-hg-icon-query" type="primary" @click="submit">查询</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import DepCodeTree from '@/views/comm/depCodeTree';

export default {
  name: 'search',
  components: {
    DepCodeTree
  },
  data() {
    return {
      ruleForm: {
        userId: '',
        taskType: 'system',
        depCode: []
      },
      manOptions: [
        { label: 'system', value: 'system' }
      ],
      rules: {}
    };
  },
  computed: {
    ...mapGetters({
      userInfor: 'user/userInfor'
    })
  },
  methods: {
    handelFormData() {
      const form = JSON.parse(JSON.stringify(this.ruleForm));
      let param = {
        userId: form.userId,
        taskType: form.taskType,
        depCode: form.depCode.length > 0 ? form.depCode.pop() : ''
      };
      for (let key in param) {
        if (!param[key]) {
          delete param[key];
        }
      }

      return param;
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          console.warn('submit!');
          const param = this.handelFormData();
          this.$emit('searchFn', param);// emit
        }
        else {
          console.warn('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
